import React, { Component } from "react";

export class PaginaNoExiste extends Component {
  render() {
    return (
      <div>
        <h1>Página no existe.</h1>
      </div>
    );
  }
}

export default PaginaNoExiste;



// WEBPACK FOOTER //
// ./src/componentes/PaginaNoExiste.js